import { LucideArrowDown, LucideArrowUp, LucideRepeat } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router";
import { RootState, useAppDispatch } from "../../../redux/store";
import { setTopNavNameTitle } from "../../../redux/features/mobileLayout/slice";
import { useSelector } from "react-redux";

const CannotWorkActionables: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { scheduleDetail } = useSelector((state: RootState) => state.schedule);

    const handleShiftSwapClicked = () => {
        dispatch(setTopNavNameTitle("Trade Shift"));
        navigate("/m-swap-trade");
    };

    const actions = [
        {
            title: "Trade Shift",
            description: "Trade my shift with someone else's shift",
            icon: <LucideRepeat className="w-6 h-6 text-blue-600" />,
            action: handleShiftSwapClicked,
        },
        {
            title: "Release Shift",
            description: "Find someone to cover my shift",
            icon: <LucideArrowDown className="w-6 h-6 text-blue-600" />,
        },
        {
            title: "Drop Shift",
            description: "Drop your shift, manager will be notified",
            icon: <LucideArrowUp className="w-6 h-6 text-blue-600" />,
        },
    ];

    return (
        <div className="h-full bg-white text-gray-900 p-4">
            <div className="flex flex-col gap-4">
                {scheduleDetail?.action_button?.can_swap && (
                    <div className="p-4 rounded-md border border-gray-400 flex items-center gap-4 bg-gray-100"
                    onClick={handleShiftSwapClicked}
                    >
                        <div className="flex items-center justify-center h-10 w-10">
                            <LucideRepeat className="w-6 h-6 text-blue-600" />
                        </div>
                        <div>
                            <div className="font-semibold text-sm">Trade Shift</div>
                            <div className="text-xs text-gray-600 mt-1">Trade my shift with someone else's shift</div>
                        </div>
                    </div>
                )}
                {/* {actions.map((action, idx) => (
                    <div
                        key={idx}
                        className="p-4 rounded-md border border-gray-400 flex items-center gap-4 bg-gray-100"
                        onClick={action.action}
                    >
                        <div className="flex items-center justify-center h-10 w-10">{action.icon}</div>
                        <div>
                            <div className="font-semibold text-sm">{action.title}</div>
                            <div className="text-xs text-gray-600 mt-1">{action.description}</div>
                        </div>
                    </div>
                ))} */}
            </div>
        </div>
    );
};

export default CannotWorkActionables;
